import { c as _c } from "react/compiler-runtime";
import GroupCreateCIC from "@/components/groups/page/create/config/GroupCreateCIC";
import GroupCreateLevel from "@/components/groups/page/create/config/GroupCreateLevel";
import GroupCreateRep from "@/components/groups/page/create/config/GroupCreateRep";
import GroupCreateTDH from "@/components/groups/page/create/config/GroupCreateTDH";
import GroupCreateCollections from "@/components/groups/page/create/config/nfts/GroupCreateCollections";
import GroupCreateNfts from "@/components/groups/page/create/config/nfts/GroupCreateNfts";
import type { ApiCreateGroup } from "@/generated/models/ApiCreateGroup";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import { CreateWaveInlineGroupRuleType } from "./createWaveInlineGroupBuilder";
import CreateWaveInlineGroupXtdhGrant from "./CreateWaveInlineGroupXtdhGrant";
export default function CreateWaveInlineGroupRuleEditor(t0) {
  const $ = _c(44);
  const {
    draft,
    activeRule,
    onDraftChange
  } = t0;
  if (activeRule === null) {
    return null;
  }
  switch (activeRule) {
    case CreateWaveInlineGroupRuleType.LEVEL:
      {
        let t1;
        if ($[0] !== draft || $[1] !== onDraftChange) {
          t1 = level => onDraftChange({
            ...draft,
            group: {
              ...draft.group,
              level
            }
          });
          $[0] = draft;
          $[1] = onDraftChange;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        let t2;
        if ($[3] !== draft.group.level || $[4] !== t1) {
          t2 = <GroupCreateLevel level={draft.group.level} setLevel={t1} />;
          $[3] = draft.group.level;
          $[4] = t1;
          $[5] = t2;
        } else {
          t2 = $[5];
        }
        return t2;
      }
    case CreateWaveInlineGroupRuleType.TDH:
      {
        let t1;
        if ($[6] !== draft || $[7] !== onDraftChange) {
          t1 = tdh => onDraftChange({
            ...draft,
            group: {
              ...draft.group,
              tdh
            }
          });
          $[6] = draft;
          $[7] = onDraftChange;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        let t2;
        if ($[9] !== draft.group.tdh || $[10] !== t1) {
          t2 = <GroupCreateTDH tdh={draft.group.tdh} setTDH={t1} />;
          $[9] = draft.group.tdh;
          $[10] = t1;
          $[11] = t2;
        } else {
          t2 = $[11];
        }
        return t2;
      }
    case CreateWaveInlineGroupRuleType.CIC:
      {
        let t1;
        if ($[12] !== draft || $[13] !== onDraftChange) {
          t1 = cic => onDraftChange({
            ...draft,
            group: {
              ...draft.group,
              cic
            }
          });
          $[12] = draft;
          $[13] = onDraftChange;
          $[14] = t1;
        } else {
          t1 = $[14];
        }
        let t2;
        if ($[15] !== draft.group.cic || $[16] !== t1) {
          t2 = <GroupCreateCIC cic={draft.group.cic} setCIC={t1} />;
          $[15] = draft.group.cic;
          $[16] = t1;
          $[17] = t2;
        } else {
          t2 = $[17];
        }
        return t2;
      }
    case CreateWaveInlineGroupRuleType.REP:
      {
        let t1;
        if ($[18] !== draft || $[19] !== onDraftChange) {
          t1 = rep => onDraftChange({
            ...draft,
            group: {
              ...draft.group,
              rep
            }
          });
          $[18] = draft;
          $[19] = onDraftChange;
          $[20] = t1;
        } else {
          t1 = $[20];
        }
        let t2;
        if ($[21] !== draft.group.rep || $[22] !== t1) {
          t2 = <GroupCreateRep rep={draft.group.rep} setRep={t1} />;
          $[21] = draft.group.rep;
          $[22] = t1;
          $[23] = t2;
        } else {
          t2 = $[23];
        }
        return t2;
      }
    case CreateWaveInlineGroupRuleType.NFTS:
      {
        let t1;
        if ($[24] !== draft || $[25] !== onDraftChange) {
          t1 = owns_nfts_0 => onDraftChange({
            ...draft,
            group: {
              ...draft.group,
              owns_nfts: owns_nfts_0
            }
          });
          $[24] = draft;
          $[25] = onDraftChange;
          $[26] = t1;
        } else {
          t1 = $[26];
        }
        let t2;
        if ($[27] !== draft.group.owns_nfts || $[28] !== t1) {
          t2 = <GroupCreateNfts nfts={draft.group.owns_nfts} setNfts={t1} />;
          $[27] = draft.group.owns_nfts;
          $[28] = t1;
          $[29] = t2;
        } else {
          t2 = $[29];
        }
        return t2;
      }
    case CreateWaveInlineGroupRuleType.COLLECTIONS:
      {
        let t1;
        if ($[30] !== draft || $[31] !== onDraftChange) {
          t1 = owns_nfts => onDraftChange({
            ...draft,
            group: {
              ...draft.group,
              owns_nfts
            }
          });
          $[30] = draft;
          $[31] = onDraftChange;
          $[32] = t1;
        } else {
          t1 = $[32];
        }
        let t2;
        if ($[33] !== draft.group.owns_nfts || $[34] !== t1) {
          t2 = <GroupCreateCollections nfts={draft.group.owns_nfts} setNfts={t1} />;
          $[33] = draft.group.owns_nfts;
          $[34] = t1;
          $[35] = t2;
        } else {
          t2 = $[35];
        }
        return t2;
      }
    case CreateWaveInlineGroupRuleType.XTDH_GRANT:
      {
        let t1;
        if ($[36] !== draft || $[37] !== onDraftChange) {
          t1 = is_beneficiary_of_grant_id => onDraftChange({
            ...draft,
            group: {
              ...draft.group,
              is_beneficiary_of_grant_id: is_beneficiary_of_grant_id ?? null
            }
          });
          $[36] = draft;
          $[37] = onDraftChange;
          $[38] = t1;
        } else {
          t1 = $[38];
        }
        let t2;
        if ($[39] !== draft.group.is_beneficiary_of_grant_id || $[40] !== t1) {
          t2 = <CreateWaveInlineGroupXtdhGrant beneficiaryGrantId={draft.group.is_beneficiary_of_grant_id} setBeneficiaryGrantId={t1} />;
          $[39] = draft.group.is_beneficiary_of_grant_id;
          $[40] = t1;
          $[41] = t2;
        } else {
          t2 = $[41];
        }
        return t2;
      }
    default:
      {
        let t1;
        if ($[42] !== activeRule) {
          t1 = assertUnreachable(activeRule);
          $[42] = activeRule;
          $[43] = t1;
        } else {
          t1 = $[43];
        }
        return t1;
      }
  }
}